export const SEND_TO_RAMBLER_PICKER_CONSTS = {
  checkedInvalidRubric: 'Выбрана рубрика, публикации которой\nне отправляются в Рамблер',
  inRamblerRssMsg: 'В Рамблер',
  ramblerTitleMaxLength: 70,
  titleCharactersLimitWasReached: 'Превышен лимит символов в заголовке\n(должен быть не более 70 символов)'
}
